import ValidateModule from "./ValidateModule";

import type AjaxRequestBroker from "../AjaxRequestBroker";
import type { IEventChannel, ApiOpts } from "../model/Models";

const $ = global.$;
const es = global.es;

/**
 * @class TenantAdminModule
 */
export default class TenantAdminModule {
    private eventChannel: IEventChannel;
    private rqBroker: AjaxRequestBroker;

    /**
     * 
     * @param eventChannel 
     * @param rqBroker 
     */
    constructor(eventChannel: IEventChannel, rqBroker: AjaxRequestBroker) {
        this.eventChannel = eventChannel;
        this.rqBroker = rqBroker;

        // TODO FIXME Does this even make sense nowadays?
        eventChannel.addListener("onDestroy", () => {
            // prevent memory leaks when the map widget is destroyed
            this.eventChannel = this.rqBroker = null;
        });

        this.load = this.load.bind(this);
//        this.update = this.update.bind(this);
//        this.remove = this.remove.bind(this);
        this.changeUserPassword = this.changeUserPassword.bind(this);
    }
    
    /**
     * load single tenant
     * 
     * @param id
     * @param opts
     * 
     * @returns a jquery deferred object resolved when tenant is loaded.
     */
    load(id?: number, opts?: ApiOpts) {
        if (!ValidateModule.checkInt(id, true)) {
            return es.util.deferred.rejected();
        }
        
        let url = es.url + "loadTenant";
        if (id) {
            url = url+'?id='+id;
        }

        return this.rqBroker.doGet({
            url: url,
            opts: opts
        });
    }
    
//    /**
//     * update the tenant detail and config
//     * 
//     * @param tenant
//     * @param opts
//     * 
//     * @returns a jquery deferred object resolved when tenant is updated.
//     */
//    update(tenant: object, opts?: any) {
//        if (!ValidateModule.checkMandatoryArg(tenant)) {
//            return es.util.deferred.rejected();
//        }
//        
//        return this.rqBroker.doPut({
//            url: context.url + "/updateTenant",
//            data: es.util.url.stringify(tenant)
//        }).done((rs) => {
//            // TODO process new tenant data.
//        });
//    }
//    
//    /**
//     * remove tenant(s)
//     * 
//     * @param ids the id of tenant(s)
//     * @return a jquery deferred object resolved when tenant is removed.
//     */
//    remove(ids: number[], opts?: any) {
//        es.log.error("UnimplementedException: This method has not been implemented yet");
//        /*
//        ValidateModule.checkIds(ids);
//        
//        return rqBroker.doDelete({
//            url: context.url + "/deleteTenant",
//            data: {'ids': ids}
//        });
//        */
//    }
    
    /**
     * Updates a user password
     * 
     * @param userName 
     * @param oldPassword 
     * @param newPassword 
     * @param opts 
     * 
     * @returns a jquery deferred object resolved when the request has completed
     */
    changeUserPassword(userName: string, oldPassword: string, newPassword: string, opts?: ApiOpts) {
        if (!ValidateModule.checkMandatoryArg(userName) ||
            !ValidateModule.checkMandatoryArg(oldPassword) ||
            !ValidateModule.checkMandatoryArg(newPassword)) {
            return es.util.deferred.rejected();
        }

        const parseParams = {
            userName: userName,
            oldPassword: oldPassword,
            newPassword: newPassword
        };

        return this.rqBroker.doPost({
            url: es.api.getURL('password') + '/change',
            data: parseParams,
            opts: $.extend(true, opts, {suppressDefaultErrorHandling: true})
        });
    }
}
